import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Pages/Home";
import MarketingAgencyPage from "./components/Pages/MarketingAgencyPage";
import StudioAgencyPage from "./components/Pages/StudioAgencyPage";
import DigitalAgencyPage from "./components/Pages/DigitalAgencyPage";
import ServicePage from "./components/Pages/ServicePage";
import AboutPage from "./components/Pages/AboutPage";
import BlogPage from "./components/Pages/BlogPage";
import BlogListPage from "./components/Pages/BlogListPage";
import BlogDetailsPage from "./components/Pages/BlogDetailsPage";
// import PortfolioPage from "./components/Pages/PortfolioPage";
import CourtDetailsPage from "./components/Pages/CourtDetailsPage";
import CaseStudyDetailsPage from "./components/Pages/CaseStudyDetailsPage";
import TeamPage from "./components/Pages/TeamPage";
import TeamDetailsPage from "./components/Pages/TeamDetailsPage";
import ContactPage from "./components/Pages/ContactPage";
import GroupPadelCoaching from "./components/Pages/GroupPadelCoaching";
import GroupPadelCoachingEmbedded from "./components/Pages/GroupPadelCoachingEmbedded";
import PrivateCoaching from "./components/Pages/PrivateCoaching";
import PrivateCoachingEmbedded from "./components/Pages/PrivateCoachingEmbedded";
import Layout2 from "./components/Layout/Layout2";
import TechStartupPage from "./components/Pages/TechStartupPage";
import ServiceDetailsPage from "./components/Pages/ServiceDetailsPage";
import Shop from "./components/Pages/Shop";
import ProductDetails from "./components/Pages/Shop/ProductDetails";
import Cart from "./components/Pages/Shop/Cart";
import Checkout from "./components/Pages/Shop/Checkout";
import Success from "./components/Pages/Shop/Success";
// import Wishlist from "./components/Dashboard/Wishlist";
import Layout3 from "./components/Layout/Layout3";
import ErrorPage from "./components/Pages/ErrorPage";
import SigninSignup from "./components/Pages/SigninSignup";
import CourtBooking from "./components/Pages/Shop/Booking";
import Courts from "./components/Pages/Courts";
import { Provider } from "react-redux";
import { store } from "./store";
import BookingHistory from "./components/Pages/BookingHistory";
import Dashboard from "./components/Dashboard";
// import Bookings from "./components/Dashboard/Bookings";
// import AccountDetails from "./components/Dashboard/AccountDetails";
import PaymentStatus from "./components/Pages/Shop/PaymentStatus";
// import Logout from './components/Dashboard/Logout';
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";
import TermsOfUse from "./components/Pages/TermsOfUse";
import RefundPolicy from "./components/Pages/RefundPolicy";
// import SimplePopup from "./SimplePopup.jsx";
// ... existing imports ...

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<Layout darkMode />}>
          <Route
            path="marketing-agency"
            element={<MarketingAgencyPage darkMode />}
          />
          <Route path="studio-agency" element={<StudioAgencyPage darkMode />} />
          <Route
            path="digital-agency"
            element={<DigitalAgencyPage darkMode />}
          />
          <Route path="about" element={<AboutPage darkMode />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="booking-history" element={<BookingHistory />} />
          <Route path="signin-signup" element={<SigninSignup />} />
          <Route
            path="service/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-list" element={<BlogListPage />} />
          <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
          <Route path="courts" element={<Courts />} />
          <Route path="court/court-detail" element={<CourtDetailsPage />} />
          <Route path="case-study-details" element={<CaseStudyDetailsPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team/:teamDetailsId" element={<TeamDetailsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="group-padel-coaching" element={<GroupPadelCoaching />} />
          <Route path="group-padel-coaching-form" element={<GroupPadelCoachingEmbedded />} />
          <Route path="private-coaching" element={<PrivateCoaching />} />
          <Route path="private-coaching-form" element={<PrivateCoachingEmbedded />} />
          <Route path="privacy-policy" element={<PrivacyPolicy darkMode />} />
          <Route path="terms-of-use" element={<TermsOfUse darkMode />} />
          <Route path="refund-policy" element={<RefundPolicy darkMode />} />
        </Route>

        <Route path="/" element={<Layout2 darkMode />}>
          <Route index element={<Home />} />
          <Route path="tech-startup" element={<TechStartupPage />} />
        </Route>

        <Route path="/" element={<Layout3 darkMode />}>
          <Route path="shop" element={<Shop />} />
          <Route path="shop/:productId" element={<ProductDetails />} />
          <Route path="shop/cart" element={<Cart />} />
          <Route path="shop/checkout" element={<Checkout />} />
          <Route path="booking/success" element={<Success />} />
          {/* <Route path="shop/wishlist" element={<Wishlist />} /> */}
          <Route path="shop/booking" element={<CourtBooking />} />
        </Route>

        {/* Light Mode Routes */}
        <Route path="/light/" element={<Layout />}>
          {/* ... existing light mode routes ... */}
        </Route>

        <Route path="/light/" element={<Layout2 />}>
          <Route index element={<Home />} />
          <Route path="tech-startup" element={<TechStartupPage />} />
        </Route>

        <Route path="/light/" element={<Layout3 />}>
          <Route path="shop" element={<Shop />} />
          <Route path="shop/:productId" element={<ProductDetails />} />
          <Route path="shop/cart" element={<Cart />} />
          <Route path="shop/checkout" element={<Checkout />} />
          <Route path="shop/success" element={<Success />} />
          {/* <Route path="shop/wishlist" element={<Wishlist />} /> */}
        </Route>

        {/* Dashboard Routes - Remove these separate routes */}
        {/* <Route path="/dashboard/bookings" element={<Bookings />} />
        <Route path="/dashboard/account-details" element={<AccountDetails />} />
        <Route path="/dashboard/wishlist" element={<Wishlist />} /> */}

        {/* Keep only the main dashboard route */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Comment out or remove this if PaymentStatus component doesn't exist */}
        <Route path="/payment/status" element={<PaymentStatus />} />

        {/* Error Route */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      
      {/* Simple Popup - hidden for now */}
      {/* <SimplePopup /> */}
    </Provider>
  );
}

export default App;
